module.exports = __webpack_public_path__ + "media/images/icons/icon_search_grey-9f86516f25835195de76c103e294d3cf.svg";